import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    label: "Selecione um Colaborador",
    loading: _ctx.isLoadingCollaboratorsInfo,
    "item-value": 'userId',
    "item-title": 'name',
    "return-object": true,
    items: _ctx.users,
    clearable: false,
    "hide-details": !_ctx.required,
    "no-data-text": 
      _ctx.isLoadingCollaboratorsInfo == true
        ? 'Carregando...'
        : 'Não há nenhum colaborador'
    ,
    "onUpdate:menu": _cache[0] || (_cache[0] = (value) => (_ctx.isSelectMenuOpen = value)),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _ctx.$emit('update:value', value))
  }, {
    "no-data": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.isLoadingCollaboratorsInfo
            ? "Carregando..."
            : "Não há nenhum colaborador"), 1)
    ]),
    _: 1
  }, 8, ["loading", "items", "hide-details", "no-data-text"]))
}